import React from "react"
import { Container, Row, Col } from "reactstrap"
import { FaFacebookSquare, FaInstagram, FaEnvelope } from "react-icons/fa"
import Link from "../../components/link"
import styled from "styled-components"
import footerItems from "../../data/footer.json"

const FooterStyling = styled.footer`
  padding: 3rem 0;
  background: ${({ theme }) => theme.backgroundSecondary};
  a,
  a:hover {
    color: inherit;
  }
  ul {
    color: rgba(0, 0, 0, 0.5);
    -webkit-padding-start: 0;
    padding: 0;
    & > li {
      list-style: none;
      a,
      a:hover {
        color: inherit;
      }
    }
  }
`

const SocialLink = ({ Icon, url }) => (
  <Link href={url} className="mr-2">
    <Icon size={30} />
  </Link>
)
const EmailLink = ({ Icon, email }) => (
  <Link href={`mailto:${email}`} className="mr-2">
    <Icon size={30} />
  </Link>
)

const FooterLink = ({ to, children }) => (
  <li>
    <Link to={to}>{children}</Link>
  </li>
)

let Footer = () => (
  <FooterStyling>
    <Container fluid>
      <Row className="d-flex justify-content-between">
        {footerItems.map((item, i) => (
          <Col
            key={i}
            md={{ size: 6, order: 2 * i }}
            xl={{ size: 3, order: 1 }}
          >
            <h5>{item.name}</h5>
            <ul>
              {item.dropdownItems.map((dropdownItem, index) => (
                <FooterLink key={index} to={dropdownItem.url}>
                  {dropdownItem.name}
                </FooterLink>
              ))}
            </ul>
          </Col>
        ))}
        <Col md={{ size: 6, order: 1 }} xl={{ size: 3, order: 1 }}>
          <h5>Kontaktiere uns</h5>
          <EmailLink Icon={FaEnvelope} email="info@artgreetings.de" />
          {/* <SocialLink Icon={FaFacebookSquare} url="https://www.facebook.com" /> */}
          <SocialLink
            Icon={FaInstagram}
            url="http://www.instagram.com/artgreetings"
          />
        </Col>
      </Row>
    </Container>
  </FooterStyling>
)

export default Footer
